import { render, staticRenderFns } from "./CustomGeneralSelect.vue?vue&type=template&id=081ebeea&scoped=true&"
import script from "./CustomGeneralSelect.vue?vue&type=script&lang=js&"
export * from "./CustomGeneralSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomGeneralSelect.vue?vue&type=style&index=0&id=081ebeea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081ebeea",
  null
  
)

export default component.exports